(function () {
  var removing = false;

  function discontinuedLines() {
    return Array.from(document.querySelectorAll('[data-ks-discontinued-line="true"][data-cart-line-key]'));
  }

  function checkoutButtons(disabled) {
    document.querySelectorAll('[name="checkout"], a[href*="/checkout"], .cart__checkout-button').forEach(function (button) {
      if ('disabled' in button) button.disabled = disabled;
      button.setAttribute('aria-disabled', String(disabled));
    });
  }

  function notice(message) {
    var node = document.getElementById('KS-Discontinued-Cart-Notice');
    if (!node) {
      node = document.createElement('div');
      node.id = 'KS-Discontinued-Cart-Notice';
      node.className = 'ks-discontinued-cart-notice';
      node.setAttribute('role', 'alert');
      document.body.appendChild(node);
    }
    node.textContent = message;
    node.hidden = false;
  }

  async function removeDiscontinuedLines() {
    var lines = discontinuedLines();
    if (!lines.length || removing) return;
    removing = true;
    checkoutButtons(true);
    notice('A discontinued product was removed from your cart.');
    var updates = {};
    lines.forEach(function (line) { updates[line.dataset.cartLineKey] = 0; });
    try {
      var response = await fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
      if (!response.ok) throw new Error('Cart update failed');
      window.location.reload();
    } catch (error) {
      removing = false;
      checkoutButtons(true);
      notice('Your cart contains a discontinued product. Remove it before checkout.');
    }
  }

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('[name="checkout"], a[href*="/checkout"], .cart__checkout-button');
    if (!checkout || !discontinuedLines().length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    removeDiscontinuedLines();
  }, true);

  var observer = new MutationObserver(removeDiscontinuedLines);
  function start() {
    removeDiscontinuedLines();
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
